import React from 'react';

const logo = process.env.PUBLIC_URL + '/img/eunsa-logo.png';
const unsaLogo = process.env.PUBLIC_URL + '/img/unsa.png';

const content = {
    bs: {
        title: 'Stranica je u izradi',
        text: 'Javne stranice eUNSA sistema su u pripremi i uskoro će biti dostupne.',
        login: 'Prijava na sistem',
        copy: '© 2026 Univerzitet u Sarajevu — UTIC.'
    },
    en: {
        title: 'Page under construction',
        text: 'The public pages of the eUNSA system are being prepared and will be available soon.',
        login: 'Sign in to the system',
        copy: '© 2026 University of Sarajevo — UTIC.'
    }
};

function getInitialLang() {
    try { return localStorage.getItem('publicLang') || 'bs'; } catch (e) { return 'bs'; }
}

export default function UnderConstruction() {
    const c = content[getInitialLang()] || content.bs;

    return (
        <div className="uc-page">
            <style>{`
                .uc-page {
                    --uc-bg: #080c14;
                    --uc-text: #eaf1f8;
                    --uc-muted: #8a97a9;
                    --uc-blue: #5aa1d8;
                    --uc-border: rgba(255, 255, 255, 0.08);
                    font-family: 'Inter', system-ui, sans-serif;
                    color: var(--uc-text);
                    background: var(--uc-bg);
                    min-height: 100vh;
                    display: flex; flex-direction: column; align-items: center; justify-content: center;
                    text-align: center; padding: 40px 24px; position: relative; overflow: hidden;
                }
                .uc-page::before {
                    content: ""; position: fixed; inset: 0; z-index: 0;
                    background:
                        radial-gradient(circle at 50% 35%, rgba(29, 110, 164, 0.28), transparent 55%),
                        radial-gradient(circle at 85% 80%, rgba(29, 110, 164, 0.18), transparent 50%),
                        var(--uc-bg);
                }
                .uc-page > * { position: relative; z-index: 1; }
                .uc-logos { display: flex; align-items: center; justify-content: center; gap: 14px; margin-bottom: 30px; }
                .uc-logos img { height: 72px; width: auto; border-radius: 10px; }
                .uc-logos img.uc-unsa { height: 54px; }
                .uc-page h1 { font-size: clamp(26px, 4.4vw, 36px); font-weight: 800; letter-spacing: -.7px; margin: 0 0 14px; }
                .uc-page p { color: var(--uc-muted); font-size: 16px; max-width: 480px; margin: 0 auto 32px; line-height: 1.65; }
                .uc-links { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
                .uc-links a {
                    display: inline-flex; align-items: center; text-decoration: none;
                    padding: 11px 22px; border-radius: 100px; font-size: 14px; font-weight: 600;
                    border: 1px solid var(--uc-border); color: var(--uc-text);
                    background: rgba(255, 255, 255, .04); transition: border-color .2s, background .2s;
                }
                .uc-links a:hover { border-color: rgba(90,161,216,.45); background: rgba(29,110,164,.12); }
                .uc-links a.uc-primary { background: linear-gradient(120deg, #1d6ea4, var(--uc-blue)); border-color: transparent; color: #fff; }
                .uc-copy { color: var(--uc-muted); font-size: 13px; opacity: .7; margin-top: 40px; }
            `}</style>

            <div className="uc-logos">
                <img src={logo} alt="eUNSA" />
                <img className="uc-unsa" src={unsaLogo} alt="Univerzitet u Sarajevu" />
            </div>

            <h1>{c.title}</h1>
            <p>{c.text}</p>

            <div className="uc-links">
                <a className="uc-primary" href="/">{c.login}</a>
            </div>

            <p className="uc-copy">{c.copy}</p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/views/Public/UnderConstruction/UnderConstruction.js